import { z } from 'zod';
import { nonNegativeNumber, optionalUuidString } from '../zod-helpers/index.js';
import { PRODUCT_CONSTRAINTS } from './constraints.js';
export const updateProductInputSchema = z.object({
    num: z
        .string()
        .trim()
        .min(1, `${PRODUCT_CONSTRAINTS.num.label} cannot be empty.`)
        .max(PRODUCT_CONSTRAINTS.num.maxLength)
        .optional()
        .nullable(),
    brandId: optionalUuidString('Invalid brand selection.').optional().nullable(),
    uomId: optionalUuidString('Invalid UOM selection.').optional().nullable(),
    name: z.string().trim().max(PRODUCT_CONSTRAINTS.name.maxLength).optional().nullable(),
    description: z
        .string()
        .trim()
        .max(PRODUCT_CONSTRAINTS.description.maxLength)
        .optional()
        .nullable(),
    price: nonNegativeNumber('Product price').optional().nullable(),
    sku: z.string().max(PRODUCT_CONSTRAINTS.sku.maxLength).optional().nullable(),
    upc: z.string().max(PRODUCT_CONSTRAINTS.upc.maxLength).optional().nullable(),
});
//# sourceMappingURL=update-input.js.map